export * from './deliverable.service';
import { DeliverableService } from './deliverable.service';
export * from './deliverable.serviceInterface';
export const APIS = [DeliverableService];
